// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_m4vbX {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._sidebarTabsButton_6hxfz {
  border: none;
  border-bottom: var(--default-grid-baseline) solid transparent !important;
  border-radius: var(--border-radius-small);
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  font-size: var(--default-font-size);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--default-grid-baseline);
  padding: var(--border-radius-small);
  transition: background-color var(--animation-quick), border-bottom-color var(--animation-quick);
  min-width: var(--default-clickable-area);
}
._sidebarTabsButton_6hxfz:hover {
  background-color: var(--color-background-hover) !important;
}
._sidebarTabsButton_6hxfz:active, ._sidebarTabsButton_6hxfz:focus {
  background-color: var(--color-main-background) !important;
}
._sidebarTabsButton_6hxfz * {
  cursor: pointer;
}
._sidebarTabsButton_selected_eBHM- {
  border-bottom-color: var(--color-primary-element) !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  cursor: default;
}
._sidebarTabsButton_selected_eBHM-:hover {
  background-color: var(--color-primary-element-light-hover) !important;
  color: var(--color-primary-element-light-text) !important;
}
._sidebarTabsButton_selected_eBHM- * {
  cursor: default;
}
._sidebarTabsButton__name_YlW5S {
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}
._sidebarTabsButton_selected_eBHM- ._sidebarTabsButton__name_YlW5S {
  font-weight: bold;
}
._sidebarTabsButton__icon_MPS-D {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
._sidebarTabsButton__legacyIcon_rzPOu {
  background-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-1e2d5bfb] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-sidebar-tabs[data-v-1e2d5bfb] {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 100%;
}
.app-sidebar-tabs__nav[data-v-1e2d5bfb] {
  display: flex;
  justify-content: stretch;
  margin: 10px 8px 0 8px;
  border-bottom: 1px solid var(--color-border);
}
.app-sidebar-tabs__tab[data-v-1e2d5bfb] {
  flex: 1 1 1px;
}
.app-sidebar-tabs__content[data-v-1e2d5bfb] {
  position: relative;
  min-height: 256px;
  height: 100%;
}
.app-sidebar-tabs__content--multiple[data-v-1e2d5bfb] > :not(section) {
  display: none;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
@property --app-sidebar-offset {
  syntax: "<length>";
  initial-value: 0;
  inherits: true;
}
body {
  /**
   * The padding between the toggle button and the page border
   */
  --app-sidebar-padding: calc(var(--default-grid-baseline, 4px) * 2);
  /**
   * The minimal offset width required to be reserved for the toggle button.
   * Automatically changes to 0 when there is no toggle button.
   */
  --app-sidebar-offset: 0;
  transition: --app-sidebar-offset 0ms !important;
}
body:has(.app-sidebar.slide-right-enter-active),
body:has(.app-sidebar.slide-right-leave-active) {
  transition: --app-sidebar-offset var(--animation-quick);
}
body:has(.app-sidebar__toggle) {
  --app-sidebar-offset: calc(var(--app-sidebar-padding) + var(--default-clickable-area));
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-d66d2f51] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}

/*
	Sidebar: to be used within #content
	app-content will be shrunk properly
*/
.app-sidebar[data-v-d66d2f51] {
  --app-sidebar-width: clamp(300px, 27vw, 500px);
  --app-sidebar-padding: calc(var(--default-grid-baseline, 4px) * 2);
  width: var(--app-sidebar-width);
  z-index: 1500;
  top: 0;
  inset-inline-end: 0;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  flex-shrink: 0;
  height: 100%;
  border-inline-start: 1px solid var(--color-border);
  background: var(--color-main-background);
  position: relative;
}
.app-sidebar__toggle[data-v-d66d2f51] {
  position: absolute !important;
  inset-block-start: var(--app-sidebar-padding);
  inset-inline-end: var(--app-sidebar-padding);
  z-index: 1001;
}
.app-sidebar .app-sidebar-header[data-v-d66d2f51] {
  --app-sidebar-close-button-offset: calc(var(--default-clickable-area) + var(--app-sidebar-padding));
}
.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-d66d2f51] {
  position: absolute;
  z-index: 100;
  top: var(--app-sidebar-padding);
  inset-inline-end: var(--app-sidebar-padding);
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info[data-v-d66d2f51] {
  flex-direction: row;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__figure[data-v-d66d2f51] {
  --figure-size: calc(52px + var(--app-sidebar-padding));
  z-index: 2;
  width: var(--figure-size);
  height: var(--figure-size);
  margin: calc(var(--app-sidebar-padding) / 2);
  border-radius: 3px;
  flex: 0 0 auto;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc[data-v-d66d2f51] {
  padding-inline-start: 0;
  flex: 1 1 auto;
  min-width: 0;
  padding-inline-end: calc(var(--default-clickable-area) + var(--app-sidebar-close-button-offset));
  padding-top: var(--app-sidebar-padding);
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-d66d2f51] {
  padding-inline-end: var(--app-sidebar-close-button-offset);
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-d66d2f51] {
  z-index: 3;
  position: absolute;
  top: calc(var(--app-sidebar-padding) / 2);
  inset-inline-start: calc(-1 * var(--default-clickable-area));
  gap: 0;
}
.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__menu[data-v-d66d2f51] {
  top: var(--app-sidebar-padding);
  inset-inline-end: var(--app-sidebar-close-button-offset);
  position: absolute;
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__menu[data-v-d66d2f51] {
  position: absolute;
  top: var(--app-sidebar-padding);
  inset-inline-end: var(--app-sidebar-close-button-offset);
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc[data-v-d66d2f51] {
  padding-inline-end: calc(var(--default-clickable-area) + var(--app-sidebar-close-button-offset));
}
.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-d66d2f51] {
  padding-inline-end: var(--app-sidebar-close-button-offset);
}
.app-sidebar .app-sidebar-header .app-sidebar-header__info[data-v-d66d2f51] {
  display: flex;
  flex-direction: column;
}
.app-sidebar .app-sidebar-header__figure[data-v-d66d2f51] {
  width: 100%;
  height: 250px;
  max-height: 250px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.app-sidebar .app-sidebar-header__figure--with-action[data-v-d66d2f51] {
  cursor: pointer;
}
.app-sidebar .app-sidebar-header__desc[data-v-d66d2f51] {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-inline: var(--app-sidebar-padding);
  padding-block: var(--app-sidebar-padding) calc(var(--app-sidebar-padding) / 2);
  gap: 0 4px;
}
.app-sidebar .app-sidebar-header__desc--with-tertiary-action[data-v-d66d2f51] {
  padding-inline-start: 6px;
}
.app-sidebar .app-sidebar-header__desc--editable .app-sidebar-header__mainname-form[data-v-d66d2f51], .app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__mainname-form[data-v-d66d2f51] {
  margin-top: -2px;
  margin-bottom: -2px;
}
.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__subname[data-v-d66d2f51] {
  margin-top: -2px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-d66d2f51] {
  display: flex;
  height: var(--default-clickable-area);
  width: var(--default-clickable-area);
  justify-content: center;
  flex: 0 0 auto;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-d66d2f51] {
  box-shadow: none;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-d66d2f51]:not([aria-pressed=true]):hover {
  box-shadow: none;
  background-color: var(--color-background-hover);
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container[data-v-d66d2f51] {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container[data-v-d66d2f51] {
  display: flex;
  align-items: center;
  min-height: var(--default-clickable-area);
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-d66d2f51] {
  padding: 0;
  min-height: 30px;
  font-size: 20px;
  line-height: 30px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-d66d2f51] .linkified {
  cursor: pointer;
  text-decoration: underline;
  margin: 0;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form[data-v-d66d2f51] {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form input.app-sidebar-header__mainname-input[data-v-d66d2f51] {
  flex: 1 1 auto;
  margin: 0;
  padding: 7px;
  font-size: 20px;
  font-weight: bold;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__menu[data-v-d66d2f51] {
  margin-inline-start: 5px;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname[data-v-d66d2f51],
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] {
  overflow: hidden;
  width: 100%;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] {
  color: var(--color-text-maxcontrast);
  font-size: var(--default-font-size);
  padding: 0;
}
.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] * {
  vertical-align: text-bottom;
}
.app-sidebar .app-sidebar-header .app-sidebar-header__mainname--hidden[data-v-d66d2f51] {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  margin: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
.app-sidebar .app-sidebar-header__description[data-v-d66d2f51] {
  display: flex;
  align-items: center;
  margin: 0 10px;
}
@media only screen and (max-width: 512px) {
.app-sidebar[data-v-d66d2f51] {
    position: absolute;
    --app-sidebar-width: 100vw;
}
}
.slide-right-leave-active[data-v-d66d2f51],
.slide-right-enter-active[data-v-d66d2f51] {
  transition-duration: var(--animation-quick);
  transition-property: margin-inline-end;
}
.slide-right-enter-to[data-v-d66d2f51],
.slide-right-leave[data-v-d66d2f51] {
  margin-inline-end: 0;
}
.slide-right-enter-from[data-v-d66d2f51],
.slide-right-leave-to[data-v-d66d2f51] {
  margin-inline-end: calc(-1 * var(--app-sidebar-width));
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcAppSidebar-Ci7hXMpX.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,wEAAwE;EACxE,yCAAyC;EACzC,8CAA8C;EAC9C,6BAA6B;EAC7B,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;EACnC,+FAA+F;EAC/F,wCAAwC;AAC1C;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,4DAA4D;EAC5D,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,qEAAqE;EACrE,yDAAyD;AAC3D;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;;IAEE;EACF,kEAAkE;EAClE;;;IAGE;EACF,uBAAuB;EACvB,+CAA+C;AACjD;AACA;;EAEE,uDAAuD;AACzD;AACA;EACE,sFAAsF;AACxF,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;CAGC;AACD;EACE,8CAA8C;EAC9C,kEAAkE;EAClE,+BAA+B;EAC/B,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kDAAkD;EAClD,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,mGAAmG;AACrG;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,4CAA4C;EAC5C,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sDAAsD;EACtD,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gGAAgG;EAChG,uCAAuC;AACzC;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,4DAA4D;EAC5D,MAAM;AACR;AACA;EACE,+BAA+B;EAC/B,wDAAwD;EACxD,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,wDAAwD;AAC1D;AACA;EACE,gGAAgG;AAClG;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,8EAA8E;EAC9E,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;AACA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;AACA;;EAEE,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;;EAEE,oBAAoB;AACtB;AACA;;EAEE,sDAAsD;AACxD","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_m4vbX {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._sidebarTabsButton_6hxfz {\n  border: none;\n  border-bottom: var(--default-grid-baseline) solid transparent !important;\n  border-radius: var(--border-radius-small);\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  font-size: var(--default-font-size);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: var(--default-grid-baseline);\n  padding: var(--border-radius-small);\n  transition: background-color var(--animation-quick), border-bottom-color var(--animation-quick);\n  min-width: var(--default-clickable-area);\n}\n._sidebarTabsButton_6hxfz:hover {\n  background-color: var(--color-background-hover) !important;\n}\n._sidebarTabsButton_6hxfz:active, ._sidebarTabsButton_6hxfz:focus {\n  background-color: var(--color-main-background) !important;\n}\n._sidebarTabsButton_6hxfz * {\n  cursor: pointer;\n}\n._sidebarTabsButton_selected_eBHM- {\n  border-bottom-color: var(--color-primary-element) !important;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  cursor: default;\n}\n._sidebarTabsButton_selected_eBHM-:hover {\n  background-color: var(--color-primary-element-light-hover) !important;\n  color: var(--color-primary-element-light-text) !important;\n}\n._sidebarTabsButton_selected_eBHM- * {\n  cursor: default;\n}\n._sidebarTabsButton__name_YlW5S {\n  font-weight: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n}\n._sidebarTabsButton_selected_eBHM- ._sidebarTabsButton__name_YlW5S {\n  font-weight: bold;\n}\n._sidebarTabsButton__icon_MPS-D {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n._sidebarTabsButton__legacyIcon_rzPOu {\n  background-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-1e2d5bfb] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-sidebar-tabs[data-v-1e2d5bfb] {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1 1 100%;\n}\n.app-sidebar-tabs__nav[data-v-1e2d5bfb] {\n  display: flex;\n  justify-content: stretch;\n  margin: 10px 8px 0 8px;\n  border-bottom: 1px solid var(--color-border);\n}\n.app-sidebar-tabs__tab[data-v-1e2d5bfb] {\n  flex: 1 1 1px;\n}\n.app-sidebar-tabs__content[data-v-1e2d5bfb] {\n  position: relative;\n  min-height: 256px;\n  height: 100%;\n}\n.app-sidebar-tabs__content--multiple[data-v-1e2d5bfb] > :not(section) {\n  display: none;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n@property --app-sidebar-offset {\n  syntax: \"<length>\";\n  initial-value: 0;\n  inherits: true;\n}\nbody {\n  /**\n   * The padding between the toggle button and the page border\n   */\n  --app-sidebar-padding: calc(var(--default-grid-baseline, 4px) * 2);\n  /**\n   * The minimal offset width required to be reserved for the toggle button.\n   * Automatically changes to 0 when there is no toggle button.\n   */\n  --app-sidebar-offset: 0;\n  transition: --app-sidebar-offset 0ms !important;\n}\nbody:has(.app-sidebar.slide-right-enter-active),\nbody:has(.app-sidebar.slide-right-leave-active) {\n  transition: --app-sidebar-offset var(--animation-quick);\n}\nbody:has(.app-sidebar__toggle) {\n  --app-sidebar-offset: calc(var(--app-sidebar-padding) + var(--default-clickable-area));\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-d66d2f51] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n\n/*\n\tSidebar: to be used within #content\n\tapp-content will be shrunk properly\n*/\n.app-sidebar[data-v-d66d2f51] {\n  --app-sidebar-width: clamp(300px, 27vw, 500px);\n  --app-sidebar-padding: calc(var(--default-grid-baseline, 4px) * 2);\n  width: var(--app-sidebar-width);\n  z-index: 1500;\n  top: 0;\n  inset-inline-end: 0;\n  display: flex;\n  overflow-x: hidden;\n  overflow-y: auto;\n  flex-direction: column;\n  flex-shrink: 0;\n  height: 100%;\n  border-inline-start: 1px solid var(--color-border);\n  background: var(--color-main-background);\n  position: relative;\n}\n.app-sidebar__toggle[data-v-d66d2f51] {\n  position: absolute !important;\n  inset-block-start: var(--app-sidebar-padding);\n  inset-inline-end: var(--app-sidebar-padding);\n  z-index: 1001;\n}\n.app-sidebar .app-sidebar-header[data-v-d66d2f51] {\n  --app-sidebar-close-button-offset: calc(var(--default-clickable-area) + var(--app-sidebar-padding));\n}\n.app-sidebar .app-sidebar-header > .app-sidebar__close[data-v-d66d2f51] {\n  position: absolute;\n  z-index: 100;\n  top: var(--app-sidebar-padding);\n  inset-inline-end: var(--app-sidebar-padding);\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info[data-v-d66d2f51] {\n  flex-direction: row;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__figure[data-v-d66d2f51] {\n  --figure-size: calc(52px + var(--app-sidebar-padding));\n  z-index: 2;\n  width: var(--figure-size);\n  height: var(--figure-size);\n  margin: calc(var(--app-sidebar-padding) / 2);\n  border-radius: 3px;\n  flex: 0 0 auto;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc[data-v-d66d2f51] {\n  padding-inline-start: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  padding-inline-end: calc(var(--default-clickable-area) + var(--app-sidebar-close-button-offset));\n  padding-top: var(--app-sidebar-padding);\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-d66d2f51] {\n  padding-inline-end: var(--app-sidebar-close-button-offset);\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-d66d2f51] {\n  z-index: 3;\n  position: absolute;\n  top: calc(var(--app-sidebar-padding) / 2);\n  inset-inline-start: calc(-1 * var(--default-clickable-area));\n  gap: 0;\n}\n.app-sidebar .app-sidebar-header--compact.app-sidebar-header--with-figure .app-sidebar-header__info .app-sidebar-header__desc .app-sidebar-header__menu[data-v-d66d2f51] {\n  top: var(--app-sidebar-padding);\n  inset-inline-end: var(--app-sidebar-close-button-offset);\n  position: absolute;\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__menu[data-v-d66d2f51] {\n  position: absolute;\n  top: var(--app-sidebar-padding);\n  inset-inline-end: var(--app-sidebar-close-button-offset);\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc[data-v-d66d2f51] {\n  padding-inline-end: calc(var(--default-clickable-area) + var(--app-sidebar-close-button-offset));\n}\n.app-sidebar .app-sidebar-header:not(.app-sidebar-header--with-figure) .app-sidebar-header__desc.app-sidebar-header__desc--without-actions[data-v-d66d2f51] {\n  padding-inline-end: var(--app-sidebar-close-button-offset);\n}\n.app-sidebar .app-sidebar-header .app-sidebar-header__info[data-v-d66d2f51] {\n  display: flex;\n  flex-direction: column;\n}\n.app-sidebar .app-sidebar-header__figure[data-v-d66d2f51] {\n  width: 100%;\n  height: 250px;\n  max-height: 250px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.app-sidebar .app-sidebar-header__figure--with-action[data-v-d66d2f51] {\n  cursor: pointer;\n}\n.app-sidebar .app-sidebar-header__desc[data-v-d66d2f51] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding-inline: var(--app-sidebar-padding);\n  padding-block: var(--app-sidebar-padding) calc(var(--app-sidebar-padding) / 2);\n  gap: 0 4px;\n}\n.app-sidebar .app-sidebar-header__desc--with-tertiary-action[data-v-d66d2f51] {\n  padding-inline-start: 6px;\n}\n.app-sidebar .app-sidebar-header__desc--editable .app-sidebar-header__mainname-form[data-v-d66d2f51], .app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__mainname-form[data-v-d66d2f51] {\n  margin-top: -2px;\n  margin-bottom: -2px;\n}\n.app-sidebar .app-sidebar-header__desc--with-subname--editable .app-sidebar-header__subname[data-v-d66d2f51] {\n  margin-top: -2px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions[data-v-d66d2f51] {\n  display: flex;\n  height: var(--default-clickable-area);\n  width: var(--default-clickable-area);\n  justify-content: center;\n  flex: 0 0 auto;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-d66d2f51] {\n  box-shadow: none;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__tertiary-actions .app-sidebar-header__star[data-v-d66d2f51]:not([aria-pressed=true]):hover {\n  box-shadow: none;\n  background-color: var(--color-background-hover);\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container[data-v-d66d2f51] {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container[data-v-d66d2f51] {\n  display: flex;\n  align-items: center;\n  min-height: var(--default-clickable-area);\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-d66d2f51] {\n  padding: 0;\n  min-height: 30px;\n  font-size: 20px;\n  line-height: 30px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname[data-v-d66d2f51] .linkified {\n  cursor: pointer;\n  text-decoration: underline;\n  margin: 0;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form[data-v-d66d2f51] {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: center;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__mainname-form input.app-sidebar-header__mainname-input[data-v-d66d2f51] {\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 7px;\n  font-size: 20px;\n  font-weight: bold;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname-container .app-sidebar-header__menu[data-v-d66d2f51] {\n  margin-inline-start: 5px;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__mainname[data-v-d66d2f51],\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] {\n  overflow: hidden;\n  width: 100%;\n  margin: 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] {\n  color: var(--color-text-maxcontrast);\n  font-size: var(--default-font-size);\n  padding: 0;\n}\n.app-sidebar .app-sidebar-header__desc .app-sidebar-header__name-container .app-sidebar-header__subname[data-v-d66d2f51] * {\n  vertical-align: text-bottom;\n}\n.app-sidebar .app-sidebar-header .app-sidebar-header__mainname--hidden[data-v-d66d2f51] {\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n  margin: 0;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n.app-sidebar .app-sidebar-header__description[data-v-d66d2f51] {\n  display: flex;\n  align-items: center;\n  margin: 0 10px;\n}\n@media only screen and (max-width: 512px) {\n.app-sidebar[data-v-d66d2f51] {\n    position: absolute;\n    --app-sidebar-width: 100vw;\n}\n}\n.slide-right-leave-active[data-v-d66d2f51],\n.slide-right-enter-active[data-v-d66d2f51] {\n  transition-duration: var(--animation-quick);\n  transition-property: margin-inline-end;\n}\n.slide-right-enter-to[data-v-d66d2f51],\n.slide-right-leave[data-v-d66d2f51] {\n  margin-inline-end: 0;\n}\n.slide-right-enter-from[data-v-d66d2f51],\n.slide-right-leave-to[data-v-d66d2f51] {\n  margin-inline-end: calc(-1 * var(--app-sidebar-width));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
